import { COMPANY_ALL_ACTIONS_TYPE } from "../actions-type";

const initialState = {
  companyData: [],
  companyDropdownData: [],
  totalLength: 0,
  hasMore: true,
  loading: false,
};

export const companyPaginationReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_ALL_ACTIONS_TYPE.GET_COMPANY_PAGINATION:
      return {
        ...state,
        companyData: [...state.companyData, ...action.payload.companies],
        totalLength: action.payload.totalLength,
        hasMore: !(action.payload.companies.length < 20),
      };
    case COMPANY_ALL_ACTIONS_TYPE.GET_COMPANY_DROPDOWN:
      return {
        ...state,
        companyDropdownData: action.payload,
      };
    case COMPANY_ALL_ACTIONS_TYPE.RESET_COMPANY_PAGINATION:
      return {
        ...state,
        companyData: [],
        totalLength: 0,
        hasMore: true,
      };
    case COMPANY_ALL_ACTIONS_TYPE.COMPANY_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case COMPANY_ALL_ACTIONS_TYPE.CREATE_COMPANY:
      return {
        ...state,
        companyData: [action.payload, ...state.companyData],
        totalLength: state.totalLength + 1,
      };
    case COMPANY_ALL_ACTIONS_TYPE.UPDATE_COMPANY:
      return {
        ...state,
        companyData: state.companyData.map((company) =>
          company._id === action.payload._id ? action.payload : company,
        ),
      };
    default:
      return state;
  }
};
